/**
 * Internal dependencies
 */
import connectionStatusActions from '../components/with-connection-status/state/actions';

const actions = {
	...connectionStatusActions,
};

export default actions;
